export const Config = {
  apiHost: 'https://gowatchit.com',
  apiUrl: 'https://gowatchit.com/api/v3',
  websiteUrl: 'https://gowatchit.com',
};

export default Config;



// WEBPACK FOOTER //
// ./src/shared/helpers/config.js